export default __webpack_public_path__ + "static/media/chicagoBearsVideo-2x.1fabd785.jpg";